"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearSequence = void 0;
function linearSequence({ firstTerm, commonDifference, numTerms }) {
    const terms = [];
    for (let i = 0; i < numTerms; i++) {
        terms.push(firstTerm + i * commonDifference);
    }
    return terms;
}
exports.linearSequence = linearSequence;
